export const selectIsDraft = ({eviteEvent}) => (eviteEvent?.status || 'draft') === 'draft';
export const selectEventOptionsDesign = ({eviteEvent}) => eviteEvent?.options?.design;
